import { render, staticRenderFns } from "./RecordAppraisalList.vue?vue&type=template&id=66598033"
import script from "./RecordAppraisalList.vue?vue&type=script&lang=js"
export * from "./RecordAppraisalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports